module.exports = __webpack_public_path__ + "img/csen-logo.43eefbce.jpg";